/* eslint-disable react/prop-types */
import { Box, Grid } from '@material-ui/core';
import TextFieldPurple from './TextFieldPurple';
import TextFieldGray from './TextFieldGray';
import React from 'react';
import ImageOfficeLine from './images/img_office_line.svg';
import ImageArrow from './images/img_arrow.svg';

class OfficeIAdressnImput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { numColor: '#BCBCBC' };
  }

  handeleFocus() {
    this.setState({ numColor: 'black' });
  }

  render() {
    return (
      <Box m={2} textAlign="center">
        <Box position="relative" textAlign="center">
          <img src={ImageOfficeLine} />
          <Box position="absolute" top={10} left={0} right={0}>
            <h2 className="office-typename">{this.props.name}</h2>
            <h5 className="office_discription1">{this.props.nameEN}</h5>
            <h6 className="office_discription2">{this.props.discript}</h6>
          </Box>
        </Box>

        <h3 className="imput-tittle2">{this.props.dataName1}</h3>

        <Grid container alignItems="center" justify="center">
          <Grid item xs={1}></Grid>
          <Grid item xs={0.5}>
            <Box height={70}>
              <TextFieldPurple
                className="office-free-imput"
                id="outlined-basic"
                margin="dense"
                variant="outlined"
                onChange={(e) => {
                  this.props.handleNum1Change(e.target.value);
                }}
                onFocus={() => this.handeleFocus()}
                value={this.props.num1}
                inputProps={{
                  style: { fontSize: 30, textAlign: 'center', fontFamily: 'Noto Sans JP', color: this.state.numColor },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={1}>
            <h3 className="imput-percent">%</h3>
          </Grid>
        </Grid>
        <Box marginTop={1}>
          <img width={13} src={ImageArrow} />
        </Box>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={1}></Grid>
          <Grid item xs={0.5}>
            <Box height={70}>
              <TextFieldGray
                className="office-free-imput"
                id="outlined-basic"
                margin="dense"
                variant="outlined"
                onChange={(e) => {
                  this.props.handleNum2Change(e.target.value);
                }}
                onFocus={() => this.handeleFocus()}
                value={this.props.num2}
                inputProps={{
                  style: { fontSize: 30, textAlign: 'center', fontFamily: 'Noto Sans JP', color: this.state.numColor },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={1}>
            <h3 className="imput-percent">%</h3>
          </Grid>
        </Grid>
        <h3 className="imput-tittle-bottom">{this.props.dataName2}</h3>
      </Box>
    );
  }
}

export default OfficeIAdressnImput;
